import { STEP_TYPE_ENUM } from 'services/api/constants'
import { SUBMISSION_VIEW_ENUM, SubmissionStatusInOverview } from 'state/submissions'
import { BLOCK_TYPES_WITH_PARTIPOSTER_CONTENT, CustomStepBlock, StepState } from 'state/tasks'

type StepTypesStatuses = Partial<Record<STEP_TYPE_ENUM, true>>
export type SubmissionStatusAvailability = Record<SubmissionStatusInOverview, StepTypesStatuses>

interface GetStepTypeAvailableStatus {
    stepList: StepState[]
    isEngagementStepType: (type: string) => boolean
    isUrlOrScreenshotSubmissionStepType: (type: string) => boolean
}

// get an object which provide status availability for overview submission table redirection
// if status not available, submission table will not provide link for that cell
export const getStepTypeAvailabiltyStatus = ({
    stepList,
    isEngagementStepType,
    isUrlOrScreenshotSubmissionStepType,
}: GetStepTypeAvailableStatus): SubmissionStatusAvailability => {
    const result: SubmissionStatusAvailability = {
        [SUBMISSION_VIEW_ENUM.PENDING]: {},
        [SUBMISSION_VIEW_ENUM.FOR_REVIEW]: {},
        [SUBMISSION_VIEW_ENUM.EDITS_REQUESTED]: {},
        [SUBMISSION_VIEW_ENUM.COMPLETED]: {},
    }

    stepList.forEach(({ type, data }) => {
        if (
            [STEP_TYPE_ENUM.POST_TO_IG_POST, STEP_TYPE_ENUM.POST_TO_FB_POST, STEP_TYPE_ENUM.POST_TO_IG_STORY].indexOf(
                type,
            ) >= 0
        ) {
            result[SUBMISSION_VIEW_ENUM.PENDING][type] = true
            result[SUBMISSION_VIEW_ENUM.COMPLETED][type] = true
        } else if (isEngagementStepType(type) || isUrlOrScreenshotSubmissionStepType(type)) {
            result[SUBMISSION_VIEW_ENUM.PENDING][type] = true
            result[SUBMISSION_VIEW_ENUM.EDITS_REQUESTED][type] = true
            result[SUBMISSION_VIEW_ENUM.COMPLETED][type] = true
        } else if (type === STEP_TYPE_ENUM.PURCHASE_PRODUCT || type === STEP_TYPE_ENUM.ATTEND_EVENT) {
            result[SUBMISSION_VIEW_ENUM.COMPLETED][type] = true
        } else if (type === STEP_TYPE_ENUM.CUSTOM) {
            // any type because of base StepState also provide any as block type
            const submissionBlocks =
                data.blocks &&
                data.blocks.filter((block: any) => BLOCK_TYPES_WITH_PARTIPOSTER_CONTENT.indexOf(block.type) >= 0)
            if (submissionBlocks.length === 0) {
                result[SUBMISSION_VIEW_ENUM.COMPLETED][type] = true
            } else {
                result[SUBMISSION_VIEW_ENUM.PENDING][type] = true
                result[SUBMISSION_VIEW_ENUM.FOR_REVIEW][type] = true
                result[SUBMISSION_VIEW_ENUM.EDITS_REQUESTED][type] = true
                result[SUBMISSION_VIEW_ENUM.COMPLETED][type] = true
            }
        } else {
            result[SUBMISSION_VIEW_ENUM.PENDING][type] = true
            result[SUBMISSION_VIEW_ENUM.FOR_REVIEW][type] = true
            result[SUBMISSION_VIEW_ENUM.EDITS_REQUESTED][type] = true
            result[SUBMISSION_VIEW_ENUM.COMPLETED][type] = true
        }
    })

    return result
}

export const isNoneSubmitBlockExisted = (step: StepState) => {
    // adjusting StepState blocks type will affecting other files as well, so use assert to avoid any
    // TODO: in the future, adjust & check blocks type in StepState
    const blocks = step?.data.blocks as CustomStepBlock[]
    if (!blocks) return false
    return !blocks?.find(block => BLOCK_TYPES_WITH_PARTIPOSTER_CONTENT.includes(block.type))
}

export const isAllowedReviewStatus = (submissionView: SUBMISSION_VIEW_ENUM | null) => {
    if (!submissionView) return false
    const allowedReviewStatus = [SUBMISSION_VIEW_ENUM.PENDING, SUBMISSION_VIEW_ENUM.FOR_REVIEW]
    return allowedReviewStatus.includes(submissionView)
}
